import { render } from "./fieldDatetime.vue?vue&type=template&id=6c921610&scoped=true"
import script from "./fieldDatetime.vue?vue&type=script&lang=js"
export * from "./fieldDatetime.vue?vue&type=script&lang=js"

import "./fieldDatetime.vue?vue&type=style&index=0&id=6c921610&scoped=true&lang=scss"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c921610"]])

export default __exports__